(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lurevano-butterfly-product"] && !Shopify.designMode) return;
  try {
    
  const initializeLbmSections = (root = document) => {
    root.querySelectorAll('.lbm[data-section-id]').forEach((section) => {
    if (section.dataset.lbmReady === 'true') return;
    section.dataset.lbmReady = 'true';
    const mainMedia = section.querySelector('[data-lbm-main-media]');
    const mainImage = section.querySelector('[data-lbm-main-image]');
    const thumbs = section.querySelectorAll('[data-media-src]');
    const form = section.querySelector('.lbm__form');
    const optionSelects = section.querySelectorAll('[data-lbm-option]');
    const variantInput = section.querySelector('[data-lbm-variant-id]');
    const addButton = section.querySelector('[data-lbm-add]');
    const addLabel = section.querySelector('[data-lbm-add-label]');
    const price = section.querySelector('[data-lbm-price]');
    const compare = section.querySelector('[data-lbm-compare]');
    const mobileBar = section.querySelector('[data-lbm-mobile-buy]');
    const mobileButton = section.querySelector('[data-lbm-mobile-submit]');
    const mobilePrice = section.querySelector('[data-lbm-mobile-price]');
    const variantDataElement = section.querySelector('[data-lbm-variants]');
    const variants = variantDataElement ? JSON.parse(variantDataElement.textContent) : [];
    const sizeChoices = section.querySelectorAll('[data-lbm-size-choice]');
    const sizeGuide = section.querySelector('[data-lbm-size-guide]');
    const sizeGuideOpeners = section.querySelectorAll('[data-lbm-size-guide-open]');
    const sizeGuideClosers = section.querySelectorAll('[data-lbm-size-guide-close]');
    let sizeGuideOpener = null;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const updateImage = () => {
          mainImage.src = thumb.dataset.mediaSrc;
          mainImage.alt = thumb.dataset.mediaAlt || '';
          if (mainMedia) {
            mainMedia.classList.toggle('is-contain', thumb.dataset.mediaFit === 'contain');
            mainMedia.classList.toggle('is-secondary', thumb.dataset.mediaStamp === 'false');
          }
          thumbs.forEach((item) => {
            const active = item === thumb;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        };
        if (document.startViewTransition) document.startViewTransition(updateImage);
        else updateImage();
      });
    });

    const syncVariant = () => {
      const selectedOptions = Array.from(optionSelects).map((select) => select.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'Niedostępne';
        mobileButton.disabled = true;
        mobileButton.textContent = 'Niedostępne';
        return;
      }
      variantInput.value = variant.id;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Zamów swój zestaw' : 'Wyprzedane';
      mobileButton.disabled = !variant.available;
      mobileButton.textContent = variant.available ? 'Zamawiam' : 'Wyprzedane';
      price.textContent = variant.price;
      mobilePrice.textContent = variant.price;
      compare.hidden = !variant.compareAt;
      compare.textContent = variant.compareAt || '';
    };

    const syncSizeChoices = (select) => {
      sizeChoices.forEach((choice) => {
        if (choice.dataset.lbmOptionPosition !== select.dataset.lbmOptionPosition) return;
        const selected = choice.dataset.lbmOptionValue === select.value;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
    };

    sizeChoices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const select = Array.from(optionSelects).find((item) => item.dataset.lbmOptionPosition === choice.dataset.lbmOptionPosition);
        if (!select) return;
        select.value = choice.dataset.lbmOptionValue;
        syncSizeChoices(select);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    optionSelects.forEach((select) => {
      select.addEventListener('change', () => {
        syncSizeChoices(select);
        syncVariant();
      });
    });

    sizeGuideOpeners.forEach((opener) => {
      opener.addEventListener('click', () => {
        if (!sizeGuide) return;
        sizeGuideOpener = opener;
        sizeGuide.showModal();
      });
    });
    sizeGuideClosers.forEach((closer) => closer.addEventListener('click', () => sizeGuide?.close()));
    sizeGuide?.addEventListener('click', (event) => {
      const bounds = sizeGuide.getBoundingClientRect();
      const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      if (outside) sizeGuide.close();
    });
    sizeGuide?.addEventListener('close', () => sizeGuideOpener?.focus());

    form.addEventListener('submit', async (event) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;
      event.preventDefault();
      if (addButton.disabled) return;
      const originalLabel = addLabel.textContent;
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      addLabel.textContent = 'Dodaję zestaw…';
      const formData = new FormData(form);
      formData.append('sections', cartDrawer.getSectionsToRender().map((item) => item.id).join(','));
      formData.append('sections_url', window.location.pathname);
      cartDrawer.setActiveElement(addButton);
      try {
        const response = await fetch(window.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Nie udało się dodać zestawu.');
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(result);
      } catch (error) {
        addLabel.textContent = error.message || 'Spróbuj ponownie';
        setTimeout(() => syncVariant(), 2600);
      } finally {
        addButton.removeAttribute('aria-busy');
        if (addLabel.textContent === 'Dodaję zestaw…') addLabel.textContent = originalLabel;
        syncVariant();
      }
    });
    mobileButton.addEventListener('click', () => form.requestSubmit());
    section.querySelectorAll('[data-lbm-offer-submit]').forEach((button) => {
      button.addEventListener('click', () => form.requestSubmit());
    });

    const buyObserver = new IntersectionObserver(([entry]) => {
      mobileBar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: .15 });
    buyObserver.observe(form);

    const reviewMore = section.querySelector('[data-lbm-review-more]');
    if (reviewMore) {
      const reviewCards = Array.from(section.querySelectorAll('[data-lbm-review-card]'));
      reviewMore.addEventListener('click', () => {
        const nextCards = reviewCards.filter((card) => card.hidden).slice(0, 6);
        nextCards.forEach((card) => { card.hidden = false; });
        if (!reviewCards.some((card) => card.hidden)) reviewMore.hidden = true;
      });
    }
    });
  };

  const startLbmSections = () => initializeLbmSections(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startLbmSections, { once: true });
  } else {
    startLbmSections();
  }
  document.addEventListener('shopify:section:load', (event) => initializeLbmSections(event.target));

  } catch(e) { console.error(e); }
})();
})();
